<h3 style="text-align:center;font-size:1.77rem;font-weight:500">
    Licencias
</h3>

<!-- Campo de búsqueda -->
<mat-form-field appearance="outline">
    <mat-label>Buscar</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Texto a buscar">
</mat-form-field>

<!-- Spinner de carga -->
<div *ngIf="loadingData" class="spinner-container">
    <mat-spinner diameter="50"></mat-spinner>
</div>

<!-- Tabla de datos -->
<div class="mat-elevation-z0" *ngIf="!loadingData">
    <table mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="Fecha_inicio">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha Inicio</th>
            <td class="padding-table" mat-cell *matCellDef="let element"> {{ element.fechaInicio }} </td>
        </ng-container>

        <ng-container matColumnDef="Fecha_termino">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha Término</th>
            <td class="padding-table" mat-cell *matCellDef="let element"> {{ element.fechaTermino }} </td>
        </ng-container>

        <ng-container matColumnDef="Motivo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Motivo</th>
            <td mat-cell *matCellDef="let element"> {{ element.motivo }} </td>
        </ng-container>

        <ng-container matColumnDef="Estado">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Estado</th>
            <td mat-cell *matCellDef="let element">
                <span [ngStyle]="{'color': element.estado === 'SUBIDA' ? 'grey' : element.estado === 'TRAMITADA' ? 'green' : 'red'}">
                    {{ element.estado }}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="UpdateAT">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Última Modificación</th>
            <td mat-cell *matCellDef="let element"> {{ element.updatedAt | date: 'dd/MM/yyyy' }} </td>
        </ng-container>

        <ng-container matColumnDef="Acciones">
            <th mat-header-cell *matHeaderCellDef>Acciones</th>
            <td class="padding-table" mat-cell *matCellDef="let element">

                <!-- Botón para descargar licencia -->
                <!-- <button (click)="Descargar(element.id)" mat-button class="button_color_primary" style="background-color:rgb(37, 199, 228)">
                    <mat-icon style="color: white">search</mat-icon>
                </button> -->
                <p-button class="mr-2" icon="pi pi-search" (click)="Descargar(element.id)" styleClass="p-button-rounded p-button-primary p-button-outlined" ></p-button>

                <!-- Botón para eliminar licencia con spinner -->
                <!-- <button (click)="Borrar(element.id, true)" mat-raised-button color="warn">
                    <mat-icon style="color: white" *ngIf="!loading">delete</mat-icon>
                    <mat-icon style="color: white" *ngIf="loading">
                        <mat-spinner color="accent" diameter="20"></mat-spinner>
                    </mat-icon>
                </button> -->
                <p-button *ngIf="!isAuditor" class="mr-2" icon="pi pi-trash" (click)="Borrar(element.id, true)" styleClass="p-button-rounded p-button-danger p-button-outlined" ></p-button>

                <!-- Botón para descargar comprobante de licencia tramitada -->
                <!-- <button *ngIf="element.estado === 'TRAMITADA' || element.estado === 'DENUNCIADA'"
                        (click)="DescargarComprobante(element.id)"
                        mat-button style="background-color: green">
                    <mat-icon style="color: white">assignment_turned_in</mat-icon>
                </button> -->
                <p-button *ngIf="(element.estado === 'TRAMITADA' || element.estado === 'DENUNCIADA') && !isAuditor"
                class="mr-2" icon="pi pi-check-circle" (click)="DescargarComprobante(element.id)" styleClass="p-button-rounded p-button-success p-button-outlined" ></p-button>

                <!-- Botón para descargar comprobante de denuncia de licencia -->
                <!-- <button *ngIf="element.estado === 'DENUNCIADA'"
                        (click)="DescargarDenuncia(element.id)"
                        mat-button style="background-color: red">
                    <mat-icon style="color: white">assignment_turned_in</mat-icon>
                </button> -->
                <p-button *ngIf="element.estado === 'DENUNCIADA' && !isAuditor"
                class="mr-2" icon="pi pi-check-circle" (click)="DescargarDenuncia(element.id)" styleClass="p-button-rounded p-button-danger p-button-outlined" ></p-button>

                <!-- Botón para subir comprobante de trámite de licencia -->
                <!-- <button *ngIf="element.estado === 'SUBIDA'"
                        (click)="open(content,element.id)"
                        mat-button style="background-color:green">
                    <mat-icon style="color: white">file_upload</mat-icon>
                </button> -->
                <p-button *ngIf="element.estado === 'SUBIDA' && !isAuditor"
                class="mr-2" icon="pi pi-upload" (click)="open(content,element.id)" styleClass="p-button-rounded p-button-success p-button-outlined"></p-button>

                <!-- Botón para subir comprobante de denuncia de licencia -->
                <!-- <button *ngIf="element.estado === 'SUBIDA' || element.estado === 'TRAMITADA'"
                        (click)="open2(content2,element.id)"
                        mat-button style="background-color:red">
                    <mat-icon style="color: white">file_upload</mat-icon>
                </button> -->
                <p-button *ngIf="(element.estado === 'SUBIDA' || element.estado === 'TRAMITADA') && !isAuditor"
                class="mr-2" icon="pi pi-upload" (click)="open2(content2,element.id)" styleClass="p-button-rounded p-button-danger p-button-outlined"></p-button>


            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

    <!-- Paginador -->
    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons>
    </mat-paginator>


<ng-template style="border: 0px; z-index: 100" #content let-modal>

    <div class="modal-header" style="text-align: center">
        <h3> Cargar Comprobante de Tramitacion de Licencia</h3>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>


    <div class="modal-body">
<p>
<label>Subir Comprobante de Tramite  &nbsp;</label>
<input mat-input  required type="file" ng2FileSelect [uploader]="uploader"  />
</p>

<div>
Estado de Carga
<div class="progress">
<div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': uploader.progress + '%' }"></div>
</div>
</div>


</div>
<!--END Modal Body-->
<!-- Modal Footer-->
<div class="modal-footer">
<button type="button" class="btn btn-outline-danger" aria-label="Close" (click)="cerrarModal()"> <span aria-hidden="true">Cancelar</span> </button>
<button type="button" (click)="guardar()" [disabled]="!uploader.getNotUploadedItems().length" class="btn btn-outline-success">Guardar</button>

</div>
</ng-template>

<ng-template style="border: 0px; z-index: 100" #content2 let-modal>

    <div class="modal-header" style="text-align: center">
        <h3> Cargar Comprobante de Denuncia de Licencia</h3>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>


    <div class="modal-body">

<p>
<label>Subir Comprobante de Denuncia  &nbsp;</label>
<input mat-input  required type="file" ng2FileSelect [uploader]="uploader"  />
</p>

<div>
Estado de Carga
<div class="progress">
<div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': uploader.progress + '%' }"></div>
</div>
</div>


</div>
<!--END Modal Body-->
<!-- Modal Footer-->
<div class="modal-footer">
<button type="button" class="btn btn-outline-danger" aria-label="Close" (click)="cerrarModal()"> <span aria-hidden="true">Cancelar</span> </button>
<button type="button" (click)="guardar()" [disabled]="!uploader.getNotUploadedItems().length" class="btn btn-outline-success">Guardar</button>

</div>
</ng-template>
</div>

